<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
@if (formLoading) {
  <div class="kbm-search-loading">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
<div class="p-2">
  <div class="fw-bold fs-5">Reservations</div>

  <!-- Banner shown when the page was opened from an Operations-Dashboard tile
       with filters in the URL. The column-header inputs (Status multi-select,
       In / Out date inputs) don't reflect inherited values today, so this
       banner makes the active scope explicit and gives the manager a one-click
       way to clear it. Hidden in normal navigation (inheritedFilterSummary is
       null when there are no recognised dashboard query params). -->
  <div *ngIf="inheritedFilterSummary"
       style="margin: 8px 0; padding: 8px 12px; border-left: 4px solid #3B82F6;
              background: #EFF6FF; border-radius: 4px; display: flex;
              align-items: center; gap: 12px; font-size: 13px;">
    <i class="pi pi-info-circle" style="color: #3B82F6;"></i>
    <span><strong>Inherited from Operations Dashboard:</strong> {{ inheritedFilterSummary }}</span>
    <a href="javascript:void(0)" (click)="clearDashboardFilters()"
       style="margin-left: auto; color: #1D4ED8; font-weight: 600;">Clear</a>
  </div>

  <div class="reservationsTable reservation-list">
    <p-table #pt [scrollable]="true" scrollHeight="calc(100vh - 220px)" [value]="reservations" [paginator]="true" [rows]="50" [rowsPerPageOptions]="[50,250,500,1000]"
      [totalRecords]="recordTotal" [lazy]="true" (onLazyLoad)="loadLazy($event)" sortMode="multiple"
      [multiSortMeta]="multiSortMeta" selectionMode="single"
      [globalFilterFields]="['guestProfileVO.lastName','guestProfileVO.firstName','guestProfileVO.emailAddress','reservationId','orderId','reservationConfId','saleDate','checkInDate','checkOutDate','shortTermRentalVO.propertyCode','orderVO.orderIdMask', 'confirmationNumber']"
      [filterDelay]="1000" [(selection)]=" reservation" dataKey="reservationId" (onRowSelect)="onRowSelect($event)"
      showCurrentPageReport="true" [loading]="loading" [responsive]="true" styleClass="p-datatable-striped"
      currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"
      showJumpToPageInput="true">

      <ng-template pTemplate="caption">
        <div class="flex justify-content-between">
          <div class="mr-2">
            <span class="p-input-icon-right">
              <i class="pi pi-search"></i>
              <input #global pInputText type="text" [(ngModel)]="searchName"
                (input)="pt.filterGlobal($event.target.value, 'contains')" placeholder="Search" />
              </span>
              <button pButton pRipple class="ml-3 p-button-text"
                style="font-size: 100%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
              (click)="onAdvanceSearch()">Advanced Search</button>

              <!-- <button pButton label="Clear" class="ml-2 p-button-outlined" icon="pi pi-filter-slash"
            (click)="clear(pt);"></button> -->
          </div>
          <!-- <div class="mr-2">
          <span class="p-input-icon-right">
            <i class="pi pi-search"></i>
            <input #global pInputText type="text" [(ngModel)]="searchName" (input)="pt.filterGlobal($event.target.value, 'contains')"
              placeholder="Search" />
            </span>
          </div> -->
          <div class="d-block text-end">
            <span>
              <app-import-export (dataAndTagsSelected)="dataAndTagSelected($event)" [tagsourceForInput]="50"
                [dataRetrived]="reservations" (exportDataSelected)="exportSelected($event)"
                importEnabled="false" [sampleFileLink]="sampleLink" [columns]="columns"
              [importDisabled]="true"></app-import-export>
              <!--clear filters-->
              <button pButton pRipple class="p-button-text"
                style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
              (click)="reloadPage()">Clear Filters</button>

              <button pButton pRipple class="p-button-text"
                title="If you need help or are experiencing any difficulties, please call Dipesh on Ring Central at extension 907."
                style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
              (click)="openHelpAlert()">Need Help?</button>

              <!--add new-->
              <!-- <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
            routerLink="/reservation-add">New Reservation +</button> -->
            <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
            (click)="openCreateReservationPopUp()">New Reservation +</button>
          </span>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>

        <th [pSortableColumn]="'reservationStatus'">Status
          <p-sortIcon [field]="'reservationStatus'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'reservationType'">Res Type
          <p-sortIcon [field]="'reservationType'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'shortTermRentalVO.listingType'" class="text-nowrap">Listing Type
          <p-sortIcon [field]="'shortTermRentalVO.listingType'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'shortTermRentalVO.locationId'">Location
          <p-sortIcon [field]="'shortTermRentalVO.locationId'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'shortTermRentalVO.propertyCode'">Unit
          <p-sortIcon [field]="'shortTermRentalVO.propertyCode'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'guestProfileVO.lastName'">Name
          <p-sortIcon [field]="'guestProfileVO.lastName'"></p-sortIcon>
        </th>

        <th [pSortableColumn]="'checkInDateTime'">In
          <p-sortIcon [field]="'checkInDateTime'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'checkOutDateTime'">Out
          <p-sortIcon [field]="'checkOutDateTime'"></p-sortIcon>
        </th>

        <th [pSortableColumn]="'numberOfNightsStay'">Nights
          <p-sortIcon [field]="'numberOfNightsStay'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'numAdults'">Guests
          <p-sortIcon [field]="'numAdults'"></p-sortIcon>
        </th>
        <th class="text-nowrap">Grand Total</th>
        <th class="text-nowrap">Nightly Rate</th>
        <th class="text-nowrap" [pSortableColumn]="'createDate'">Created
          <p-sortIcon [field]="'createDate'"></p-sortIcon>
        </th>
        <th class="text-nowrap" [pSortableColumn]="'saleDate'">Sale Date
          <p-sortIcon [field]="'saleDate'"></p-sortIcon>
        </th>
        <th class="text-nowrap" [pSortableColumn]="'reservationHoldExpiration'">Hold Expiration
          <p-sortIcon [field]="'reservationHoldExpiration'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'orderVO.orderId'">Order #
          <p-sortIcon [field]="'orderVO.orderId'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'reservationId'">Res #
          <p-sortIcon [field]="'reservationId'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'orderVO.creditSaleToUserVO.lastName'">Sales Agent Name
          <p-sortIcon [field]="'orderVO.creditSaleToUserVO.lastName'"></p-sortIcon>
        </th>
        <th>Channel
        </th>
        <th>Source Context
        </th>
      </tr>
      <tr>
        <th>
          <p-multiSelect dropdownIcon="fa fa-caret-down" [style]="{'min-width':'200px'}" [options]="constantService.reservationStatuses"
            defaultLabel="Status" (onChange)="pt.filter($event.value, 'reservationStatus', 'in')"
          appendTo="body"></p-multiSelect>
        </th>

        <th>
          <p-multiSelect dropdownIcon="fa fa-caret-down" [style]="{'width':'100px','min-width':'100%'}" [options]="reservationTypes"
            defaultLabel="Res Type" (onChange)="pt.filter($event.value, 'reservationType', 'in')" optionLabel="name"
          appendTo="body"></p-multiSelect>
        </th>

        <th>
          <p-dropdown dropdownIcon="fa fa-caret-down" #aa [style]="{'width':'100px','min-width':'100%'}" [(ngModel)]="listingType"
            [options]="listingTypes" appendTo="body"
            (onChange)="pt.filter($event.value, 'shortTermRentalVO.listingType', 'in')"
            styleClass="p-column-filter" placeholder="Filter" [showClear]="true" optionLabel="name"
            optionValue="value" [filter]="true" filterBy="name" [showClear]="false">
            <ng-template let-option pTemplate="item">
              <span>{{option.name}}</span>
            </ng-template>
          </p-dropdown>
        </th>

        <th>
          <p-multiSelect dropdownIcon="fa fa-caret-down" [style]="{'min-width':'200px'}" [options]="constantService.locations"
            defaultLabel="Location" optionLabel="name" optionValue="locationId"
            (onChange)="pt.filter($event.value, 'shortTermRentalVO.locationId', 'in')"
          appendTo="body"></p-multiSelect>
        </th>

        <th>
          <input pInputText style="width:100px;" type="text"
            (input)="pt.filter($event.target.value, 'shortTermRentalVO.propertyCode', 'startsWith')">
          </th>
          <th>
            <input pInputText style="width:150px;" type="text"
              (input)="pt.filter($event.target.value, 'guestProfileVO.lastName', 'startsWith')">
            </th>
            <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
              style="width:100px;" type="date"
            (input)="pt.filter($event.target.value, 'checkInDateTime', 'in')"></th>
            <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
              style="width:100px;" type="date"
            (input)="pt.filter($event.target.value, 'checkOutDateTime', 'in')"></th>
            <th [ngStyle]="{'width': 'auto'}"><input pInputText style="width:100px;" type="text"
            (input)="pt.filter($event.target.value, 'numberOfNightsStay', 'contains')"></th>
            <th [ngStyle]="{'width': 'auto'}"><input pInputText style="width:100px;" type="text"
            (input)="pt.filter($event.target.value, 'numAdults', 'contains')"></th>
            <th [ngStyle]="{'width': 'auto'}"></th>
            <th [ngStyle]="{'width': 'auto'}"></th>
            <th [ngStyle]="{'width': 'auto'}">
              <input pInputText style="width:100px;" type="date"
                (input)="pt.filter($event.target.value, 'createDate', 'in')">
              </th>
              <th [ngStyle]="{'width': 'auto'}">
                <input pInputText style="width:100px;" type="date"
                  (input)="pt.filter($event.target.value, 'saleDate', 'in')">
                </th>
                <th [ngStyle]="{'width': 'auto'}"></th>
                <th>
                  <input pInputText style="width:100px;" type="text"
                    (input)="pt.filter($event.target.value, 'orderVO.orderId', 'contains')">
                  </th>
                  <th>
                    <input pInputText style="width:100px;" type="text"
                      (input)="pt.filter($event.target.value, 'reservationId', 'contains')">
                    </th>
                    <th>
                      <input pInputText style="width:100px;" type="text"
                        (input)="pt.filter($event.target.value, 'orderVO.creditSaleToUserVO.lastName', 'contains')">
                      </th>
                      <th>
                        <p-multiSelect dropdownIcon="fa fa-caret-down" [style]="{'min-width':'200px'}" [options]="constantService.refSrcImages"
                          defaultLabel="Channel" (onChange)="pt.filter($event.value, 'orderVO.referralSourceId', 'in')"
                        appendTo="body"></p-multiSelect>
                      </th>
                      <th>
                        <p-multiSelect dropdownIcon="fa fa-caret-down" [style]="{'min-width':'200px'}" [options]="constantService.referralSourceContexts"
                          defaultLabel="Source" (onChange)="pt.filter($event.value, 'referralSourceContext', 'in')"
                        appendTo="body"></p-multiSelect>
                      </th>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="body" let-reservation>
                    <tr [pSelectableRow]="reservation">
                      <td [style.background-color]="getResStatusColor(reservation.reservationStatus)">
                      {{getResStatusName(reservation.reservationStatus)}}</td>
                      <td>{{getReservationTypeName(reservation?.reservationType)}}</td>
                      <td>{{getListingTypeName(reservation?.listingType)}}</td>
                      <td>{{getLocationName(reservation?.locationId)}}</td>

                      <td>{{reservation.propertyCode}}</td>
                      <td><b>{{reservation.guestLastName}}</b></td>
                      <td style="white-space: nowrap;">{{reservation.checkInDate|date:'MM/dd/yy EEEEEE'}}</td>
                      <td style="white-space: nowrap;">{{reservation.checkOutDate|date:'MM/dd/yy EEEEEE'}}</td>
                      <td style="text-align: center;">{{reservation?.numNights}}</td>
                      <td>{{reservation?.numAdults}}/{{reservation?.numChildren}} {{reservation?.numPets}}</td>
                      <td>{{reservation.ttlExpenseWithTax|currency}}</td>
                      <td>{{reservation.revRoomRateNetPNT|currency}}</td>
                      <td>{{reservation.createDate|date:'MM/dd/yy'}}</td>
                      <td>{{reservation.saleDate|date:'MM/dd/yy'}}</td>
                      <td>{{reservation.holdExpiration|date:'MM/dd HH:MM'}}</td>
                      <td>{{reservation.orderId}} </td>
                      <td>{{reservation.reservationId}}</td>
                      <td>{{reservation.salesAgentLastName}}</td>
                      <td><img style='height: 23px; width: 80px'
                      [src]="constantService.getChannelPictureURL(reservation.referralSourceId)" /></td>
                      <td>{{constantService.getReferralSourceContextLabel(reservation.referralSourceContext)}}</td>
                    </tr>
                  </ng-template>
                  <!-- <ng-template pTemplate=" paginatorCenter"> Showing {{recordTotal < 1 ? 0 : (lazyLoadEvent.first + 1)}} -
                  {{recordTotal> 0 ? ((lazyLoadEvent.rows+ lazyLoadEvent.first) <= recordTotal ? (lazyLoadEvent.rows +
                lazyLoadEvent.first) : recordTotal) : 0}} of {{recordTotal ? recordTotal : 0}} </ng-template> -->
                <!-- 👇 Custom paginator template that allows pageLinkSize -->
                <ng-template pTemplate="paginator" let-state>
                  <p-paginator [rows]="state.rows" [totalRecords]="state.totalRecords"
                    [rowsPerPageOptions]="[50, 250, 500, 1000]" [first]="state.first"
                    (onPageChange)="state.onPageChange($event)" [pageLinkSize]="20" styleClass="p-paginator-bottom"
                    [showJumpToPageInput]="true"
                  [template]="'{totalRecords} results. Page {currentPage} of {totalPages}'"></p-paginator>
                </ng-template>

              </p-table>
            </div>

          </div>